import { render, staticRenderFns } from "./veHqChuangkouEdit.vue?vue&type=template&id=4025d19c&scoped=true"
import script from "./veHqChuangkouEdit.vue?vue&type=script&lang=js"
export * from "./veHqChuangkouEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4025d19c",
  null
  
)

export default component.exports